import { createSlice } from "@reduxjs/toolkit";
import {
  addCustomer,
  addRechargeToCustomerWallet,
  getAllBookingHistory,
  getAllCustomers,
  getCustomerChartDetails,
  getCustomerDetails,
  getCustomerDropdownList,
  getCustomerWalletTransactions,
  getPlatformVersions,
  updateCustomer,
  updateCustomerStatus,
} from "store/actions/customerSlice";

const initialState = {
  isLoading: false,
  loading: false,
  loading1: false,
  loading2: false,
  loading3: false,
  perPage: 100,
  totalCount: null,
  totalPages: null,
  currentPage: null,
  customers: [],
  customersList: [],
  customerDetails: {},
  totalCount1: null,
  totalPages1: null,
  currentPage1: null,
  customerWalletTransactions: [],
  bookingHistory: [],
  totalCount2: null,
  totalPages2: null,
  currentPage2: null,
  filterState: {
    pageNumber: 1,
    keyword: "",
    dates: [],
    selectedFilters: {
      status: -1,
      orderBy: -1,
      roleType: [],
      gender: [],
      rating: -1,
      revenueRangeMin: null,
      revenueRangeMax: null,
      platform: "",
      version: "",
      organizationId: "",
    },
  },
  customerChartDetails: [],
  versions: "",
};

const customerSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    updateFilterState: (state, action) => {
      state.filterState = {
        ...state.filterState,
        ...action.payload,
      };
    },
    resetFilterState: (state) => {
      state.filterState = initialState.filterState;
    },
    setSortedCustomers: (state, action) => {
      state.customers = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getAllCustomers.pending, (state) => {
        state.loading = true;
        state.totalCount = null;
        state.totalPages = null;
        state.currentPage = null;
      })
      .addCase(getAllCustomers.fulfilled, (state, action) => {
        state.loading = false;
        const { success } = action.payload || {};
        const { data, totalCount, totalPages, currentPage } =
          action.payload || {};
        if (success) {
          state.customers = data;
          state.totalCount = totalCount || null;
          state.totalPages = totalPages || null;
          state.currentPage = currentPage || null;
        }
      })
      .addCase(getAllCustomers.rejected, (state, action) => {
        state.loading = false;
      });

    builder
      .addCase(getCustomerDetails.pending, (state) => {
        state.loading = true;
      })
      .addCase(getCustomerDetails.fulfilled, (state, action) => {
        state.loading = false;
        const { success, data } = action.payload || {};
        if (success) {
          state.customerDetails = data;
        }
      })
      .addCase(getCustomerDetails.rejected, (state, action) => {
        state.loading = true;
      });

    builder
      .addCase(updateCustomerStatus.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(updateCustomerStatus.fulfilled, (state, action) => {
        state.isLoading = false;
        const { success } = action.payload || {};
        if (success) {
          const { id, status } = action.meta.arg;
          state.customers = state?.customers?.map((item) =>
            item._id === id ? { ...item, status: status } : item
          );
        }
      })
      .addCase(updateCustomerStatus.rejected, (state, action) => {
        state.isLoading = false;
      });

    builder
      .addCase(getAllBookingHistory.pending, (state) => {
        state.loading2 = true;
        state.totalCount2 = null;
        state.totalPages2 = null;
        state.currentPage2 = null;
      })
      .addCase(getAllBookingHistory.fulfilled, (state, action) => {
        state.loading2 = false;
        const { success } = action.payload || {};
        const { data, totalCount, totalPages, currentPage } =
          action.payload || {};
        if (success) {
          state.bookingHistory = data;
          state.totalCount2 = totalCount || null;
          state.totalPages2 = totalPages || null;
          state.currentPage2 = currentPage || null;
        }
      })
      .addCase(getAllBookingHistory.rejected, (state, action) => {
        state.loading2 = false;
      });

    builder
      .addCase(getCustomerWalletTransactions.pending, (state) => {
        state.loading1 = true;
        state.totalCount1 = null;
        state.totalPages1 = null;
        state.currentPage1 = null;
      })
      .addCase(getCustomerWalletTransactions.fulfilled, (state, action) => {
        state.loading1 = false;
        const { success } = action.payload || {};
        const { data, totalCount, totalPages, currentPage } =
          action.payload || {};
        if (success) {
          state.customerWalletTransactions = data;
          state.totalCount1 = totalCount || null;
          state.totalPages1 = totalPages || null;
          state.currentPage1 = currentPage || null;
        }
      })
      .addCase(getCustomerWalletTransactions.rejected, (state, action) => {
        state.loading1 = false;
      });

    builder
      .addCase(addRechargeToCustomerWallet.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(addRechargeToCustomerWallet.fulfilled, (state, action) => {
        state.isLoading = false;
      })
      .addCase(addRechargeToCustomerWallet.rejected, (state, action) => {
        state.isLoading = false;
      });

    builder
      .addCase(getCustomerDropdownList.pending, (state) => {})
      .addCase(getCustomerDropdownList.fulfilled, (state, action) => {
        const { success, data } = action.payload || {};
        if (success) {
          state.customersList = data || [];
        }
      })
      .addCase(getCustomerDropdownList.rejected, (state, action) => {});

    builder
      .addCase(getCustomerChartDetails.pending, (state) => {
        state.loading3 = true;
      })
      .addCase(getCustomerChartDetails.fulfilled, (state, action) => {
        state.loading3 = false;
        const { success, data } = action.payload || {};
        if (success) {
          state.customerChartDetails = data;
        }
      })
      .addCase(getCustomerChartDetails.rejected, (state, action) => {
        state.loading3 = false;
      });

    builder
      .addCase(getPlatformVersions.pending, (state) => {})
      .addCase(getPlatformVersions.fulfilled, (state, action) => {
        const { success, versions } = action.payload || {};
        if (success) {
          state.versions = versions || [];
        }
      })
      .addCase(getPlatformVersions.rejected, (state, action) => {});

    builder
      .addCase(addCustomer.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(addCustomer.fulfilled, (state, action) => {
        state.isLoading = false;
        const { success, data } = action.payload || {};
        if (success) {
          console.log(data);
        }
      })
      .addCase(addCustomer.rejected, (state, action) => {
        state.isLoading = false;
      });

    builder
      .addCase(updateCustomer.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(updateCustomer.fulfilled, (state, action) => {
        state.isLoading = false;
      })
      .addCase(updateCustomer.rejected, (state, action) => {
        state.isLoading = false;
      });
  },
});

export default customerSlice.reducer;

export const { updateFilterState, resetFilterState, setSortedCustomers } =
  customerSlice.actions;
